import React from "react";
import { useHistory } from "react-router-dom";
import { Button } from '@blueprint/ui';
import { FormFooter } from "../../../common/components/form";

import PublicFormContainer from "./PublicFormContainer";

const ForgotPasswordSuccessMessage = (): JSX.Element => {
    const history = useHistory();

    return (
        <PublicFormContainer>
            <h2 className="mb-4">Email has been sent</h2>
            <p className="mb-5">
                If your email address was previously registered, you will
                receive a reset password link. Please check your email inbox for
                further instructions.
            </p>
            <FormFooter className="d-flex mb-5">
                    <Button
                        onClick={()=> history.push("/login")}
                        type="submit"
                        className="btn btn-primary flex-grow-1"
                        variant="light.primary">Back To Login</Button>
            </FormFooter>
        </PublicFormContainer>
    );
};

export default ForgotPasswordSuccessMessage;
